import { MenuItem, MenuList } from '@material-tailwind/react';
import React, { useState } from 'react';

const menuItems = [
    {
        name: 'Course List Layouts',
        items: [{ name: 'Course List', link: '/courses-list' }],
    },
    {
        name: 'Course Single Layouts',
        items: [{ name: 'Course Single', link: '/courses-single' }],
    },
    {
        name: 'About Courses',
        items: [
            { name: 'Lesson Page', link: '/lesson-page' },
            { name: 'Instructors List', link: '/instructors-list' },
            { name: 'Instructors Single', link: '/instructors-single' },
            { name: 'Become an Instructor', link: '/become-an-instructor' },
        ],
    },
    {
        name: 'Dashboard Pages',
        items: [
            { name: 'Dashboard', link: '/dashboard' },
            { name: 'My Courses', link: '/dashboard-my-courses' },
            { name: 'Bookmarks', link: '/dashboard-all-Pages' },
            { name: 'Add Listing', link: '/dashboard-create-courses' },
            { name: 'Reviews', link: '/dashboard-reviews' },
            { name: 'Settings', link: '/dashboard-settings' },
            { name: 'Administration', link: '/administration' },
            { name: 'Assignment', link: '/assignment' },
            { name: 'Calendar', link: '/calendar' },
            { name: 'Single Dashboard', link: '/single-dashboard' },
            { name: 'Dictionary', link: '/dictionary' },
            { name: 'Forums', link: '/dashboard-forums' },
            { name: 'Grades', link: '/grades' },
            { name: 'Messages', link: '/dashboard-messages' },
            { name: 'Participants', link: '/participants' },
            { name: 'Quiz', link: '/dashboard-quizz' },
            { name: 'Survey', link: '/survey' },
        ],
    },
    {
        name: 'Popular Courses',
        items: [
            { name: 'Web Developer', link: '/web-developer' },
            { name: 'Mobile Developer', link: '/mobile-developer' },
            { name: 'Digital Marketing', link: '/digital-marketing' },
            { name: 'Development', link: '/development' },
            { name: 'Finance & Accounting', link: '/finance-accounting' },
            { name: 'Design', link: '/design' },
            { name: 'View All Courses', link: '/all-courses' },
        ],
    },
];

function CoursesDropDown({ mobile }) {
    const [expandedSections, setExpandedSections] = useState({});

    const toggleSection = (index) => {
        setExpandedSections(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    if (mobile) {
        return (
            <MenuList className={`z-[100] border-none p-0 
    ${mobile
                    ? "ml-4 w-full max-h-[80vh] overflow-y-auto dark:bg-dark-1 shadow-none"
                    : "overflow-hidden w-screen md:w-auto dark:bg-dark-1 transition-all duration-300"
                }`}
            >

                {menuItems.map((section, index) => (
                    <div key={index} className="py-2 border-b border-gray-200 dark:border-gray-700 last:border-b-0">
                        <button
                            onClick={() => toggleSection(index)}
                            className="flex justify-between items-center w-full text-left"
                        >
                            <h4 className="text-sm font-semibold text-dark-1 dark:text-white mb-1">{section.name}</h4>
                            <svg
                                className={`w-4 h-4 transition-transform ${expandedSections[index] ? 'rotate-180' : ''}`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        <div className={`overflow-hidden transition-all duration-300 ${expandedSections[index] ? 'max-h-96' : 'max-h-0'}`}>
                            <div className="space-y-1 pl-2 mt-1">
                                {section.items.map((item, i) => (
                                    <MenuItem
                                        key={i}
                                        className="text-sm text-gray-700 hover:text-blue-600 dark:text-gray-300 dark:hover:text-blue-400 pl-4"
                                    >
                                        <a href={item.link} className="block w-full py-1">
                                            {item.name}
                                        </a>
                                    </MenuItem>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </MenuList>
        );
    }

    return (
        <MenuList className='overflow-hidden z-[100] dark:bg-dark-1 border-none p-0'>
            <div className="w-full bg-white px-4 md:px-8 lg:px-12 py-4 md:py-6 rounded-md dark:bg-dark-1">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-4 md:gap-6 h-fit max-w-screen-xl mx-auto">
                    {menuItems.map((section, index) => (
                        <div key={index} className="md:col-span-1">
                            <h4 className="text-sm font-semibold text-dark-1 dark:text-white mb-2">{section.name}</h4>
                            <ul className="space-y-1">
                                {section.items.map((item, i) => (
                                    <li
                                        key={i}
                                        className="text-sm text-gray-700 hover:text-blue-600 cursor-pointer
                                        dark:text-gray-400 dark:hover:text-blue-400 transition-colors"
                                    >
                                        <a href={item.link} className="block py-1">
                                            {item.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <div className="md:col-span-2 flex flex-col justify-between bg-indigo-700 h-full
                    text-white p-4 md:p-6 rounded-md mt-4 md:mt-0">
                        <p className='font-bold text-lg md:text-xl'>
                            Join more than <br />
                            <span className="text-green-300 font-bold text-base md:text-lg">8 million learners</span>
                            <br /> worldwide
                        </p>
                        <a
                            href="#"
                            className="mt-4 inline-block text-center bg-green-500 text-dark-1 hover:bg-indigo-700 
                            hover:text-white py-3 px-4 text-base md:text-lg rounded transition border-[1.5px] 
                            border-green-500 w-full"
                        >
                            Start Learning For Free
                        </a>
                    </div>
                </div>
            </div>
        </MenuList>
    );
}

export default CoursesDropDown;